/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Duration_Not_A_Positive_IntegerInputs */

const en_us2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The time has to be a whole number of seconds above zero.`)
};

const pt_br2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo precisa ser um número inteiro de segundos maior que zero.`)
};

const es_419_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tiempo tiene que ser un número entero de segundos mayor que cero.`)
};

const pt_pt2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo tem de ser um número inteiro de segundos maior do que zero.`)
};

const fr_fr2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durée doit être un nombre entier de secondes supérieur à zéro.`)
};

const de_de2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeit muss eine ganze Zahl an Sekunden über null sein.`)
};

const it_it2_workout_duration_not_a_positive_integer = /** @type {(inputs: Workout_Duration_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tempo deve essere un numero intero di secondi maggiore di zero.`)
};

/**
* | output |
* | --- |
* | "The time has to be a whole number of seconds above zero." |
*
* @param {Workout_Duration_Not_A_Positive_IntegerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_duration_not_a_positive_integer = /** @type {((inputs?: Workout_Duration_Not_A_Positive_IntegerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Duration_Not_A_Positive_IntegerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_duration_not_a_positive_integer(inputs)
	if (locale === "es-419") return es_419_workout_duration_not_a_positive_integer(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_duration_not_a_positive_integer(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_duration_not_a_positive_integer(inputs)
	if (locale === "de-DE") return de_de2_workout_duration_not_a_positive_integer(inputs)
	if (locale === "it-IT") return it_it2_workout_duration_not_a_positive_integer(inputs)
	return en_us2_workout_duration_not_a_positive_integer(inputs)
});
export { workout_duration_not_a_positive_integer as "workout.duration_not_a_positive_integer" }